// 企业利润统计表
<template>
  <div class="mod-user">
    <div class="searchBox">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="月份" prop="takeGoodsDate">
          <el-date-picker
            v-model="dataForm.takeGoodsDate"
            type="monthrange"
            align="right"
            unlink-panels
            value-format="yyyy-MM"
            :clearable="false"
            range-separator="-"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="downLoad()" type="success">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table :data="dataList"
                @row-click="rowClick"
                show-summary
                :row-style="selectedHighlight"
                :height="this.tableHeight"
                border size="small"
                v-loading="dataListLoading"
                style="width: 100%;">
        <el-table-column prop="yearMonth" label="年月" width="60" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
        <el-table-column prop="totalProfit" label="纯利润" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
        <el-table-column prop="totalIncome" label="总收入" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
        <el-table-column prop="totalExpenditure" label="总支出" :show-overflow-tooltip="true" fixed="left">
        </el-table-column>
<!--        <el-table-column prop="freightFee" label="应收小计" :show-overflow-tooltip="true">-->
<!--        </el-table-column>-->
        <el-table-column prop="payFreightFee" label="应付小计" :show-overflow-tooltip="true">
        </el-table-column>
<!--        <el-table-column prop="salesmanFee" label="业务员提成" :show-overflow-tooltip="true">-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="serviceFee" label="客服提成" :show-overflow-tooltip="true">-->
<!--        </el-table-column>-->
        <el-table-column prop="finalWageFee" label="运输部提成" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="saleFee" label="业务部提成" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="careFee" label="客服部提成" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="supplierCost" label="供应商费用" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="maintainFee" label="客户维护费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="taxesFee" label="客户税费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="createCardFee" label="证件办证费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="insurePrice" label="车辆保险费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="totalRepairMoney" label="车辆维修费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="pumpElementFee" label="车用泵素费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="lossMoney" label="事故损失费" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="expenditureMoney" label="其他费用支出" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="incomeMoney" label="其他费用收入" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dataForm: {
        takeGoodsDate: null
      },
      showTotal: false,
      dataList: [],
      pageIndex: 1,
      getIndex: -1,
      pageSize: 20,
      tableHeight: '65vh',
      totalPage: 0,
      dataListLoading: false
    }
  },
  created () {
    let now = new Date()
    let start = new Date(now.getFullYear(), 0, 1)
    this.dataForm.takeGoodsDate = [this.dateFormatter(start, 'yyyy-MM'), this.dateFormatter(now, 'yyyy-MM')]
    this.getDataList()
  },
  methods: {
    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime && takeGoodsTime.length === 2) {
        timeParam.takeGoodsBeginDate = takeGoodsTime[0]
        timeParam.takeGoodsEndDate = takeGoodsTime[1]
      }
      this.$http({
        url: this.$http.adornUrl('/costSummary/companyProfitList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate
        })
      }).then(({ data }) => {
        if (data) {
          this.dataList = data.list
          this.totalPage = data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        if (!this.showTotal) {
          // 解决elementUI table合计行初始页面不显示问题  this.height由父组件传递过来 this.theight未表格绑定的高度
          this.tableHeight = '67vh'
          this.showTotal = true
        }
        this.dataListLoading = false
      })
    },
    downLoad () {
      let takeGoodsTime = this.dataForm.takeGoodsDate
      let timeParam = {}
      if (takeGoodsTime && takeGoodsTime.length === 2) {
        timeParam.takeGoodsBeginDate = takeGoodsTime[0]
        timeParam.takeGoodsEndDate = takeGoodsTime[1]
      }
      this.$http({
        url: this.$http.adornUrl(`/costSummary/export/companyProfit`),
        method: 'get',
        responseType: 'blob',
        params: this.$http.adornParams({
          'vehiclePlate': this.dataForm.vehiclePlate,
          'beginDate': timeParam.takeGoodsBeginDate,
          'endDate': timeParam.takeGoodsEndDate
        })
      }).then(({ data }) => {
        const blob = data
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = '企业利润统计表.xls'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    }
  }
}
</script>
<style lang="less">
  span.searchUpload {
    display: inline-block;
    margin-left: 10px;
  }
</style>
